const GOAL_API_URL =
    process.env.REACT_APP_GOAL_API_URL || '#{REACT_APP_GOAL_API_URL}#';
const GOAL_AUTH_TOKEN =
    process.env.REACT_APP_GOAL_AUTH_TOKEN || '#{REACT_APP_GOAL_AUTH_TOKEN}#';

const STRAPI_URL =
    process.env.REACT_APP_STRAPI_URL || '#{REACT_APP_STRAPI_URL}#';

export { GOAL_API_URL, GOAL_AUTH_TOKEN, STRAPI_URL };
